<template>
  <div class="box9new">
    <div class="btn" @click="openDetail">进入学习</div>
  </div>
</template>

<script>
import check from "../../../utils/check";
export default {
  data() {
    return {};
  },
  methods: {
     openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
       this.clickZiXun()
      }
      this.mai("狂野架构师-职场进阶课","进入学习",0,null)
    },
  },
};
</script>

<style lang="scss" scoped>
.box9new {
  background: url("../../../assets/coursePage/architect/box9bgc.png") no-repeat;
  width: 100%;
  height: 245px;
  background-size: cover;
  overflow: hidden;
  .btn{
    width: 360px;
	height: 68px;
	background-color: #ffffff;
	box-shadow: 14px 14px 40px 0px 
		#026cff;
	border-radius: 14px;
  font-family: PingFangSC-Semibold;
	font-size: 30px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 68px;
	letter-spacing: 2px;
  margin: 137px auto 0;
	color: #1076ff;
  text-align: center;
  }
}
</style>
